// extracted by mini-css-extract-plugin
module.exports = {"premiereHeader":"styles-module__premiereHeader___2ovJ7","pulse":"styles-module__pulse___TYv-3","premiereTitle":"styles-module__premiereTitle___vu7Kf"};